<template>
  <div>
    <!-- Campo visual — muestra seleccionadas -->
    <div class="category-field" @click="abrirSeleccion">
      <span class="field-label">Categorías *</span>
      <div class="chips-selected">
        <v-chip
          v-for="cat in modelValue"
          :key="cat.idCategory"
          size="small"
          color="green"
          variant="tonal"
          class="mr-1 mb-1"
        >
          {{ cat.name }}
        </v-chip>
        <span v-if="modelValue.length === 0" class="placeholder">
          Toca para seleccionar categorías
        </span>
      </div>
      <v-icon class="field-icon">mdi-chevron-down</v-icon>
    </div>

    <!-- Modal 1: Selección de categorías -->
    <v-dialog v-model="modalSeleccion" max-width="480">
      <v-card>
        <v-card-title class="modal-titulo">
          <span>Categorías</span>
          <v-btn
            size="small"
            color="primary"
            variant="tonal"
            prepend-icon="mdi-plus"
            @click="abrirNuevaCategoria"
          >
            Agregar
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div v-if="cargando" class="text-center py-4">
            <v-progress-circular indeterminate color="primary" size="24" />
          </div>
          <div v-else class="lista-categorias">
            <div
              v-for="cat in todasLasCategorias"
              :key="cat.idCategory"
              class="categoria-item"
              :class="{ seleccionada: estaSeleccionada(cat.idCategory) }"
              @click="toggleCategoria(cat)"
            >
              <v-icon size="18" :color="estaSeleccionada(cat.idCategory) ? 'green' : 'grey'">
                {{ estaSeleccionada(cat.idCategory) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
              </v-icon>
              <span class="cat-nombre">{{ cat.name }}</span>
              <v-btn
                icon
                size="x-small"
                variant="text"
                color="error"
                class="ml-auto"
                @click.stop="confirmarEliminarCategoria(cat)"
              >
                <v-icon size="16">mdi-delete</v-icon>
              </v-btn>
            </div>
            <div v-if="todasLasCategorias.length === 0" class="text-grey text-caption text-center py-2">
              No hay categorías. Agrega una.
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="modalSeleccion = false">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarSeleccion">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal 2: Nueva categoría -->
    <v-dialog v-model="modalNuevaCategoria" max-width="360" @after-leave="limpiarFormCategoria">
      <v-card>
        <v-card-title>Nueva categoría</v-card-title>
        <v-card-text>
          <v-alert v-if="errorCategoria" type="error" variant="tonal" density="compact" class="mb-3">
            {{ errorCategoria }}
          </v-alert>
          <v-text-field
            v-model="formCategoria.name"
            label="Nombre"
            variant="outlined"
            density="compact"
            autofocus
            @keydown.enter="guardarCategoria"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="modalNuevaCategoria = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoCategoria" @click="guardarCategoria">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal confirmar eliminar categoría -->
    <v-dialog v-model="modalEliminarCategoria" max-width="360">
      <v-card>
        <v-card-title>Eliminar categoría</v-card-title>
        <v-card-text>
          ¿Eliminar <strong>{{ categoriaAEliminar?.name }}</strong>? Se quitará de todos los lugares que la tengan.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="modalEliminarCategoria = false">Cancelar</v-btn>
          <v-btn color="error" :loading="eliminandoCategoria" @click="eliminarCategoria">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apisSites from "@/apis/apisSites";

export default {
  name: "CategoryField",
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    entityType: {
      type: String,
      default: "lugar",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      todasLasCategorias: [],
      seleccionadas: [],
      cargando: false,

      modalSeleccion: false,
      modalNuevaCategoria: false,
      modalEliminarCategoria: false,

      formCategoria: { name: "" },
      guardandoCategoria: false,
      errorCategoria: null,

      categoriaAEliminar: null,
      eliminandoCategoria: false,
    };
  },
  methods: {
    async cargarCategorias() {
      this.cargando = true;
      try {
        this.todasLasCategorias = await apisSites.getCategoriesByEntityType(this.entityType);
      } finally {
        this.cargando = false;
      }
    },
    async abrirSeleccion() {
      // Inicializar selección desde modelValue
      this.seleccionadas = this.modelValue.map((c) => ({ ...c }));
      await this.cargarCategorias();
      this.modalSeleccion = true;
    },
    estaSeleccionada(idCategory) {
      return this.seleccionadas.some((c) => c.idCategory === idCategory);
    },
    toggleCategoria(cat) {
      const idx = this.seleccionadas.findIndex((c) => c.idCategory === cat.idCategory);
      if (idx === -1) {
        this.seleccionadas.push({ ...cat });
      } else {
        this.seleccionadas.splice(idx, 1);
      }
    },
    confirmarSeleccion() {
      this.$emit("update:modelValue", [...this.seleccionadas]);
      this.modalSeleccion = false;
    },

    // Nueva categoría
    abrirNuevaCategoria() {
      this.formCategoria = { name: "" };
      this.errorCategoria = null;
      this.modalNuevaCategoria = true;
    },
    limpiarFormCategoria() {
      this.formCategoria = { name: "" };
      this.errorCategoria = null;
    },
    async guardarCategoria() {
      this.guardandoCategoria = true;
      this.errorCategoria = null;
      try {
        const resp = await apisSites.saveCategory({
          name: this.formCategoria.name,
          entityType: this.entityType,
        });
        if (typeof resp === "string") {
          this.errorCategoria = resp;
        } else {
          this.modalNuevaCategoria = false;
          await this.cargarCategorias();
          // Auto-seleccionar la recién creada
          this.seleccionadas.push({ ...resp });
        }
      } catch (e) {
        this.errorCategoria = e.response?.data || "Error al guardar";
      } finally {
        this.guardandoCategoria = false;
      }
    },

    // Eliminar categoría
    confirmarEliminarCategoria(cat) {
      this.categoriaAEliminar = cat;
      this.modalEliminarCategoria = true;
    },
    async eliminarCategoria() {
      this.eliminandoCategoria = true;
      try {
        await apisSites.deleteCategory(this.categoriaAEliminar.idCategory);
        // Quitar de seleccionadas si estaba
        this.seleccionadas = this.seleccionadas.filter(
          (c) => c.idCategory !== this.categoriaAEliminar.idCategory
        );
        this.modalEliminarCategoria = false;
        await this.cargarCategorias();
      } finally {
        this.eliminandoCategoria = false;
        this.categoriaAEliminar = null;
      }
    },
  },
};
</script>

<style scoped>
.category-field {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 10px 12px;
  cursor: pointer;
  min-height: 56px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: border-color 0.2s;
}

.category-field:hover {
  border-color: rgba(0, 0, 0, 0.87);
}

.field-label {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}

.chips-selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 24px;
}

.placeholder {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.38);
}

.field-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.54);
}

.modal-titulo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
}

.lista-categorias {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 300px;
  overflow-y: auto;
}

.categoria-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
}

.categoria-item:hover {
  background: rgba(0, 0, 0, 0.04);
}

.categoria-item.seleccionada {
  background: rgba(76, 175, 80, 0.08);
}

.cat-nombre {
  font-size: 0.9rem;
  flex: 1;
}
</style>
